import React from 'react';
import NotFound from '../../components/Common/NotFound/index';

const Error404 = () => (
  <div
    className="page-content text-center col-xs-24 col-sm-18 col-md-14"
    id="content"
  >
    <NotFound />
  </div>
);

export default Error404;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Error404.js